import * as React from 'react';

import { ErrorMessage } from '@hookform/error-message';

type FormFieldErrorProps = React.ComponentProps<typeof ErrorMessage>;

export const FormFieldError = (props: FormFieldErrorProps) => (
  <ErrorMessage
    {...props}
    render={({ message }) => (
      <span className="form-field-error-2024" role="alert">
        {message}
      </span>
    )}
  />
);
